<template>
	<modal titulo="Odin - Resumo Inteligente de Anexo" :loading="loading">

    <div class="alert alert-outline-warning alert-sm mb-3">
      <strong>ATENÇÃO:</strong> Esta funcionalidade ainda está em desenvolvimento.
      <br /> O foco desta primeira versão é sintetizar em texto as informações contidas no anexo.
      <br /> O Odin não valida a autenticidade das informações apresentadas.
      <br /> Revise atentamente os dados exibidos e, em caso de inconsistências, informe-nos para que possamos aprimorar a ferramenta.
    </div>

    <card v-if="!loading && status == 'waiting'">
      <div class="alert alert-outline-warning d-flex align-items-center">
        <div class="spinner-border spinner-border-sm text-warning mr-3" role="status"></div>
        <div>
          Resumo sendo realizado. Documentos grandes podem levar alguns minutos.
          <br /> Você pode fechar esta janela e voltar depois: o resumo continua sendo feito.
        </div>
      </div>
    </card>

    <card v-if="!loading">

      <div class="alert alert-outline-danger" v-if="status == 'error'">
        {{resposta}}
      </div>

      <div class="row gutters-xs form" v-if="resposta && status == 'complete'">
        <div class="col" id="odin-resumo-anexo">
          <span v-html="resposta" />
        </div>
      </div>

      <div class="alert alert-outline-primary" v-if="status == 'not_found'">
        Nenhum resumo encontrado
      </div>

    </card>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-2">Fechar</button>
      <v-button class="btn btn-outline-primary ml-auto" v-if="status == 'not_found' || status == 'error'" :run="run" :popover="true">
        {{ status == 'error' ? 'Tentar Novamente' : 'Criar Resumo' }}
      </v-button>
      <v-button class="btn btn-outline-primary ml-auto" v-if="status == 'complete' && permitirCriarResumosAnexos" :run="editarResumo" :popover="false">Editar Resumo</v-button>
    </template>

  </modal>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import Card from "@/components/Layout/components/Card.vue";
import Modal from "@/components/Modal";

import {marked} from "marked";
import ModalOdinEditarResumo from "@/views/Odin/modais/componentes/ModalOdinEditarResumo.vue";

export default {
  name: "ModalOdinResumoAnexo",
  components: {Card, Modal},
  props: {
    referencia : String,
    protocoloId : String
  },
  data() {
    return {
      loading: true,
      resposta: null,
      status:  'not_found',
      opened: true,
      timer: null,
      inicioEspera: null
    }
  },

  modal:{
    width: 1200,
    escapable: false
  },

  beforeDestroy() {
    this.pararConsulta();
  },

  mounted() {
      this.load();
  },

  computed:{
    permitirCriarResumosAnexos(){
      return this.$root.getPermission({id: 'PERMITIR_CRIAR_RESUMO_ANEXOS'});
    }
  },

  methods:{

      close(result) {
        this.pararConsulta();
        FrontBusiness.closeModal(result);
      },

      pararConsulta() {
        this.opened = false;
        clearTimeout(this.timer);
        this.timer = null;
      },

      // O resumo é assíncrono e pode levar minutos (OCR em lote do provedor), então a consulta não
      // tem teto: segue enquanto o modal estiver aberto, a cada 3 s no primeiro minuto e a cada 12 s
      // depois, para não martelar a API com uma espera longa.
      agendarConsulta() {
        clearTimeout(this.timer);
        const decorrido = Date.now() - (this.inicioEspera || Date.now());
        this.timer = setTimeout(() => this.load(), decorrido < 60000 ? 3000 : 12000);
      },

      async load(){
        if(!this.opened){
          return;
        }
        const aguardando = this.status == 'waiting';
        if(!aguardando){
          this.$set(this, 'loading', true);
        }
        let r = await this.$api.get(`/api/odin/protocolo/resumo/${this.referencia}`).catch(() => null);
        if(!this.opened){
          return;
        }
        if(!r && aguardando){
          // Falha passageira no meio da espera não encerra o acompanhamento.
          this.agendarConsulta();
          return;
        }
        if(r){
          this.status = r.status;
          if(r.status == 'waiting'){
            if(!this.inicioEspera){
              this.inicioEspera = Date.now();
            }
            this.$set(this, 'loading', false);
            this.agendarConsulta();
            return;
          }
          this.inicioEspera = null;
          if(r.status == 'complete'){
            let resumo = marked(r.resumo, {breaks: true});
            resumo = resumo.replaceAll("<a", "<a target='_blank'");
            this.resposta = resumo;
          }else if(r.status == 'error'){
            this.resposta = r.resumo;
          }
        }else{
          this.status = 'not_found';
        }
        this.$set(this, 'loading', false);
      },

      async run() {
        await this.$api.post(`/api/odin/protocolo/resumo/${this.referencia}`)
          .catch(e => {
            FrontBusiness.showError('', e.message)
            this.close(false);
          });

        this.status = 'not_found';
        this.inicioEspera = null;
        this.load();
      },

    async editarResumo() {
      let r = await FrontBusiness.openModal(ModalOdinEditarResumo, {
        texto: this.resposta,
        referencia: this.referencia
      });
      if(r){
        await this.load();
      }
    },

    }
  }
</script>

<style lang=scss>
#odin-resumo-anexo{

  h1, h2, h3, h4{
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 20px;
  }

  h1{
    font-size: 16pt !important;
  }
  h2{
    font-size: 13pt !important;
  }
  h3, h4{
    font-size: 11pt !important;
  }
}
</style>
